import {ComponentProps, FC} from 'react';
import {twMerge} from 'tailwind-merge';

import Loader from '@/assets/icons/loading.svg?react';

export interface ButtonProps extends ComponentProps<'button'> {
  variant?:
    | 'primary'
    | 'secondary'
    | 'cancel'
    | 'default'
    | 'default-outline'
    | 'boost'
    | 'like'
    | 'gold'
    | 'system'
    | 'delete'
    | 'delete-solid'
    | 'verify';
  size?: 'legacy' | 'standard';
  label?: string;
  loading?: boolean;
}

const Button: FC<ButtonProps> = ({
  variant = 'default',
  size = 'legacy',
  className,
  label,
  disabled,
  loading = false,
  children = null,
  ...rest
}) => {
  const renderContent = () => {
    if (loading) {
      return (
        <Loader className="m-auto inline-block h-lh max-w-fit text-white" />
      );
    }

    return (
      <span className="contents">
        {label}
        {children}
      </span>
    );
  };

  return (
    <button
      {...rest}
      disabled={disabled}
      className={twMerge(
        'h-[48px] w-full touch-manipulation select-none font-bold duration-100',
        size === 'standard' && 'h-auto w-auto px-4 text-lg',
        variant === 'default-outline' && 'rounded-lg border',
        variant === 'primary' &&
          'rounded-lg bg-primary py-2 text-white active:bg-primary-active',
        variant === 'primary' &&
          disabled &&
          'bg-primary-disabled active:bg-primary-disabled',
        variant === 'boost' &&
          'rounded-lg bg-boost py-2 text-white active:bg-boost-active',
        variant === 'boost' &&
          disabled &&
          'bg-light-boost active:bg-light-boost',
        variant === 'like' && 'rounded-lg bg-like py-2 text-white',
        variant === 'like' && disabled && 'bg-like-light active:bg-like-light',
        variant === 'gold' && 'rounded-lg bg-gold-gradient py-2',
        variant === 'secondary' &&
          'block h-[52px] w-[300px] rounded-xl border border-gray-icon bg-white px-4 py-2 text-black text-lg md:w-[530px]',
        variant === 'cancel' &&
          'rounded-lg bg-gray-300 p-1 font-semibold text-dark-gray',
        variant === 'system' &&
          'rounded-lg bg-system-blue py-2 text-lg text-white active:bg-system-blue/90',
        variant === 'system' &&
          disabled &&
          'bg-system-blue/70 active:bg-system-blue/70',
        variant === 'default' && 'mx-auto w-fit rounded-md px-4 py-2',
        variant === 'delete' && 'text-error',
        variant === 'delete-solid' && 'rounded-lg bg-error text-white',
        variant === 'verify' &&
          'rounded-lg bg-verify text-white active:bg-very-active',
        variant === 'verify' &&
          disabled &&
          'bg-verify-disabled active:bg-verify-disabled',
        className
      )}
    >
      {renderContent()}
    </button>
  );
};

export default Button;
